import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['card', 'container']
  static values = {
    currentModuleIndex: { type: Number, default: 6 },
    total: { type: Number, default: 12 },
  }

  cardTargetConnected(card) {
    if (this.isLoading) return;

    card.classList.add('min-w-0');
    card.classList.remove('min-w-[22.625rem]');

    card.classList.remove('min-w-0');
    card.classList.add('min-w-[22.625rem]');
  }

  currentModuleIndexValueChanged() {
    if (this.isLoading) return;

    const cardToCircle = this.containerTarget[this.isNext ? 'firstElementChild' : 'lastElementChild'];

    if (this.isNext) {
      this.containerTarget.appendChild(cardToCircle.cloneNode(true));
    } else {
      this.containerTarget.prepend(cardToCircle.cloneNode(true));
    }

    cardToCircle.classList.add('disintegrate');
    setTimeout(() => {
      cardToCircle.remove();
    }, 500);

    this.#toggleCards();
  }

  initialize() {
    this.isLoading = true;
  }

  connect() {
    this.#toggleCards();
    this.#activateCard(this.#currentCard());
    this.scrollToCard();

    this.isLoading = false;
  }

  next() {
    this.isNext = true;
    this.currentModuleIndexValue = (this.currentModuleIndexValue % this.totalValue) + 1;
  }

  previous() {
    this.isNext = false;
    this.currentModuleIndexValue =
      ((this.currentModuleIndexValue - 2 + this.totalValue) % this.totalValue) + 1;
  }

  scrollToCard() {
    this.containerTarget.scrollLeft = this.#currentCard().getBoundingClientRect().left - ((this.containerTarget.clientWidth / 2) - 175)
  }

  #toggleCards() {
    this.cardTargets.forEach(card => {
      if (parseInt(card.dataset.moduleIndex) === this.currentModuleIndexValue) {
        this.#activateCard(card);
      } else {
        this.#deactivateCard(card);
      }
    })
  }

  #activateCard(card) {
    card.classList.add('h-[25rem]');
    card.classList.remove('h-[15.25rem]');

    const btnTitle = card.firstElementChild.firstElementChild;

    btnTitle.classList.add('btn-primary');
    btnTitle.classList.remove('btn', 'bg-gray-200', 'text-dark-gray');

    const paragraph = card.lastElementChild;

    paragraph.classList.remove('hidden');
  }

  #deactivateCard(card) {
    card.classList.remove('h-[25rem]');
    card.classList.add('h-[15.25rem]');

    const btnTitle = card.firstElementChild.firstElementChild;

    btnTitle.classList.remove('btn-primary');
    btnTitle.classList.add('btn', 'bg-gray-200', 'text-dark-gray');

    const paragraph = card.lastElementChild;

    paragraph.classList.add('hidden');
  }

  #currentCard() {
    return this.cardTargets.find(card => parseInt(card.dataset.moduleIndex) === this.currentModuleIndexValue);
  }
}
